import React, { Component } from "react";
import { connect } from "react-redux";
import { businessgroupActions } from "../../actions/bussGroup.actions";
import { bgConstants } from "../../constants/businessGroup.constants";
import { okrDetailConstants } from "../../constants/okr/okrDetails.constants";
import DropdownComp from "../../components/dropdown/dropdown";
import LegendBox from "./legend.component";
import { withTranslation } from "react-i18next";
import { imgUrl } from '../../utils/url';
import debounce from 'lodash/debounce';

const getBubbleChartSize = (arr = []) => {
  // min chart size - any single circle at least 150px
  // max chart size - all available space
  const minCellDiameter = 150;
  const circleAmount = arr.length;
  const minChartDiameter = circleAmount > 0
    ? minCellDiameter * Math.ceil(Math.sqrt(circleAmount))
    : minCellDiameter;
  const chartWidth = window.innerWidth - 1.1 * $('.leftmenu-wrapper').width(); // minus left menu with some margin
  // minus main menu and chart legend (same size),
  // set the default menu height to 64 in case there is a race condition fetching the height
  const chartHeight = window.innerHeight - 2 * ($('#mainmenu').height() || 64);

  return {
    chartWidth: Math.max(chartWidth - 20, minChartDiameter),
    chartHeight: Math.max(chartHeight, minChartDiameter)
  };
}
class BgBubbleChart extends Component {
  constructor(props) {
    super(props);
    this.handleLegend = this.handleLegend.bind();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.props.dispatch({ type: bgConstants.GET_BUSI_SUCCESS, props });
    this.state = getBubbleChartSize();
    const chartArr = this.props.businessGroup || [];
    this.updateDimensions = debounce(() => {
      this.setState(getBubbleChartSize(chartArr));
    }, 300);
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.updateDimensions);
    // Defer initial chart render to allow DOM layout (leftmenu-wrapper, mainmenu)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.loadNewBubbleChart());
    });
  };

  componentWillUnmount = () => window.removeEventListener('resize', this.updateDimensions);

  componentDidUpdate(prevProps) {
    if (prevProps.openLegend == this.props.openLegend) {
      this.loadNewBubbleChart();
    }
  }
  handleLegend = () => {
    if (!this.props.openLegend) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.props.dispatch({ type: bgConstants.LEGEND_TOGGLE });
  };

  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleLegend();
  }
  handleSelect(e, item) {
    if (typeof item !== "undefined") {
      let data = {
        startDate: item.start,
        endDate: item.end,
        quarter: item.value
      };
      this.props.dispatch(businessgroupActions.getfilterdata(data));
      // OKR-11388: keep the address bar on heatMap=2 to match the fetch in bussGroup.actions,
      // otherwise a reload of this URL is treated as a default landing and the flag redirects away.
      const params = { heatMap: 2, status: `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}` };
      if (item.start && item.end) {
        params.startDate = item.start;
        params.endDate = item.end;
      }
      const historyUrl = wbConfig.baseUrl + "/goal/goalSummary?" + $.param(params);
      if (typeof window.history.replaceState !== "undefined") {
        window.history.replaceState({ urlPath: historyUrl, state: 0, rand: Math.random() }, "", historyUrl);
      }
    }
  }

  loadNewBubbleChart() {
    d3.selectAll(".bubbleChart svg > *").remove();
    $(".bubbleChart").html("");
    let data = this.props.businessGroup;
    let quarter = this.props.quarter;
    let filterData = [];
    const { t } = this.props;
    this.props.filterOption.forEach(element => {
      if (element.value == quarter) {
        filterData = element;
      }
    });
    if (data.length == 0) return;
    // data = data.filter(val => {
    //   return +val.scale > 0;
    // });
    const { chartWidth, chartHeight } = this.state;
    let diameter = { width: chartWidth, height: chartHeight }; //max size of the bubbles
    //color category

    let bubble = d3.layout
      .pack()
      .sort(null)
      .size([diameter.width, diameter.height])
      .padding(5);

    let svg = d3
      .select(".bubbleChart")
      .append("svg:svg")
      .attr("width", diameter.width)
      .attr("height", diameter.height)
      .style("margin-bottom", "10px")
      .attr("class", "bubble");

    //Adding the value property required for bubbles
    data = data.map(d => {
      d.value = d.scale > 0 ? (parseFloat(d.scale)+59) : 60;
      return d;
    });

    let nodes = bubble.nodes({ children: data }).filter(function(d) {
      return !d.children;
    });

    //setup the chart
    let bubbles = svg
      .selectAll("circle")
      .data(nodes)
      .enter();
    var tooltip = d3
      .select(".bubbleChart")
      .append("div")
      .attr("class", "tooltip-legend")
      .style("position", "absolute")
      .style("z-index", "10")
      .style("visibility", "hidden")
      .style("background", "#737475")
      .style("padding", "10px")
      .style("border-radius", "6px")
      .style("font-family", "Lato, Helvetica Neue, Helvetica, Arial, san-serif")
      .style("font-size", "13px")
      .style("color", "#FCFCFC");

    //create the bubbles
    bubbles
      .append("g")
      .attr("class", "g-bubble")
      .append("svg:circle")
      .attr("r", function(d) {
        if (d["scale"] == 0) {
          d.r = d.r - (10 / 100) * d.r;
        } else if (data.length <= 1) {
          d.r = d.r - (30 / 100) * d.r;
        } else if (d.r > 250) {
          d.r = d.r - (30 / 100) * d.r;
        }
        return d.r;
      })
      .attr("cx", function(d) {
        d.x = d.x + (10 / 100) * d.x;
        return d.x;
      })
      .attr("cy", function(d) {
        d.y = d.y + (2 / 100) * d.y;
        return d.y;
      })
      .style("fill", function(d) {
        return d.color;
      })
      .attr("margin", function(d) {
        return "10%";
      })
      .attr("id", function(d) {
       return "businessGrpId"+d.id;
      })
      .on("mouseover", function(d) {
        d3.select(this).attr("r", d.r + 3);
        d3.select(this).attr("class", "clickable");
        tooltip.selectAll("div").remove();
        tooltip.append("div").text(d.name).style("font-size", "14px").style("font-weight", "bold");
        tooltip.append("div").text(`${d["teamWithOkr"]} teams with ${t('OKR')}`);
        tooltip.append("div").text(`${d["totalTeam"]} total teams`);
        tooltip.style('top', `${d.y - d.r - 80}px`);
        tooltip.style('left', `${d.x - 60}px`);
        tooltip.style("visibility", "visible");
      })
      .on("mouseout", function(d) {
        if (d.r > 150) {
          d3.select(this).attr("r", d.r);
        }
        d3.select(this).attr("r", d.r);
        return tooltip.style("visibility", "hidden");
      })
      .attr("tabindex", "0")
      .attr("role", "button")
      .on("click", function(d) {
        postDataMap(d, filterData);
      });

    // a11y - handle key enter on circle
    data.forEach(d => {
      $( `#businessGrpId${d.id}` ).keydown((e) => {
        if (e.key === 'Enter') {
          postDataMap(d, filterData);
        }
      });
    });

    //format the text for each bubble
    bubbles
      .append("text")
      .attr("x", function(d) {
        return d.x;
      })
      .attr("y", function(d) {
        if (d.r < 70) {
          return d.y-15;
        }
        return d.y - 30;
      })
      .attr("text-anchor", "middle")
      .text(function(d) {
        let disp = d["scale"] + "%";
        return disp;
      })
      .style({
        fill: "#ffffff",
        "font-family": "Lato, Helvetica Neue, Helvetica, Arial, san-serif",
        "font-size": "16px",
        "font-weight": "bold",
        "pointer-events": "none"
      });

    bubbles
      .append("text")
      .attr("x", function(d) {
        return d.x;
      })
      .attr("y", function(d) {
        if (d.r < 70) {
          return d.y;
        }
        return d.y - 10;
      })
      .attr("text-anchor", "middle")
      .text(function(d) {
          return d["name"];
      })
      .style({
        fill: "#ffffff",
        "font-family": "Lato, Helvetica Neue, Helvetica, Arial, san-serif",
        "font-size": "13px",
        "font-weight": "bold",
        "pointer-events": "none"
      })
      .each(wrap);

    bubbles
      .append("text")
      .attr("x", function(d) {
        return d.x;
      })
      .attr("y", function(d) {
        if(d.r < 70){
          d.y = d.y + 10;
        }
        return d.y + 5;
      })
      .attr("text-anchor", "middle")
      .text(function(d) {
        let tmOkr = d["teamWithOkr"] + " teams with "+ t('OKR')+" \n";
          return tmOkr;
      })
      .style({
        fill: "#ffffff",
        "font-family": "Lato, Helvetica Neue, Helvetica, Arial, san-serif",
        "font-size": "11px",
        "pointer-events": "none"
      })
      .each(wrap);

    bubbles
      .append("text")
      .attr("x", function(d) {
        return d.x;
      })
      .attr("y", function(d) {
        return d.y + 17;
      })
      .attr("text-anchor", "middle")
      .text(function(d) {
        let totalTm = d["totalTeam"] + " total teams";
          return totalTm;
      })
      .style({
        fill: "#ffffff",
        "font-family": "Lato, Helvetica Neue, Helvetica, Arial, san-serif",
        "font-size": "11px",
        "pointer-events": "none"
      })
      .each(wrap);

    function wrap(d) {
      function getComputedTextLength() {
        try {
          return self.node().getComputedTextLength();
        } catch {
          return 0;
        }
      }

      var self = d3.select(this),
        width = d.r * 2,
        padding = 10,
        textLength = getComputedTextLength(),
        text = self.text();

      while (textLength > width - 2 * padding && text.length > 0) {
        text = text.slice(0, -1);
        self.text(text + "...");
        textLength = getComputedTextLength();
      }
    }

    function postDataMap(data, filtData) {
      const params = {
        team_people: 1,
        team_s: 0,
        businessGrpId: data.id,
        status: `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}`
      };
      if (filtData && filtData.start && filtData.end) {
        params.startDate = moment(filtData.start).format("MM/DD/YYYY");
        params.endDate = moment(filtData.end).format("MM/DD/YYYY");
      }
      const urlParams = typeof buildGoalSummaryUrlParams === "function"
        ? buildGoalSummaryUrlParams(params)
        : params;
      const deepLinkUrl = Object.keys(urlParams).length > 0
        ? wbConfig.baseUrl + "/goal/goalSummary?" + $.param(urlParams)
        : wbConfig.baseUrl + "/goal/goalSummary";
      setheatMapBgId({ businessGrpId: data.id });
      if (typeof window.history.pushState !== "undefined") {
        window.history.pushState({ urlPath: deepLinkUrl, state: 0, rand: Math.random() }, "", deepLinkUrl);
      }
      ajaxPageLoad(deepLinkUrl, "GET", undefined, $("#content"));
    }
  }
  render() {
    const { openLegend, filterOption, quarter, isFavorites, businessGroup, t } = this.props;
    removeLoaderWidget();
    return (
      <div>
        <div className="bg-top-header">
          <div className="heatBgTitle left" style={{ width: "35%" }}>
            <div>
             {t("Heatmap")}  <span>|</span>{t("Business Groups")}
              <div className="tooltip">
                <i
                  className={"mp-help-icon icon icon-outline-help_outline-14px"}
                />
                <span className="tooltiptext">
                  {t('This view shows the average OKR progress across all teams within each business group.')}
                </span>
              </div>
            </div>
          </div>
          <div className="right" style={{ width: "50%" }}>
            { !window.isVnextPage() ?
              <span
                className="icon pinBusiness right pined clickable pin"
                data-pinstatus={isFavorites}
                data-type="myobjective"
                data-id="2"
              ></span>
              : ''
            }

            <div className="right">
              <div
                ref={node => (this.node = node)}
                style={{ position: 'relative', display: 'inline-block', verticalAlign: 'top' }}
              >
                <div
                  tabIndex={0}
                  className="legend-top clickable"
                  onMouseEnter={this.handleLegend}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.handleLegend()
                    }
                  }}
                >
                 {t('Legend')}
                </div>
                {openLegend ? <LegendBox /> : ""}
              </div>
              <div style={{ display: 'inline-block' }}>
                <DropdownComp
                  options={filterOption}
                  defaultValue={quarter}
                  onChange={this.handleSelect}
                  optionsClass="bg-drop-container"
                  wrapperClass="bg-wrapper-dropdown q-select-filter "
                  appendId="bgchart"
                />
              </div>
            </div>
          </div>
        </div>
        {businessGroup.length > 0 ?
        <div>
        <div className="mp-card">
          <div className="mp-container">
            <div
              className="bubbleChart"
              style={{
                position: "relative",
                marginTop: "-6%"
              }}
            />
          </div>
        </div>
            </div>: <div className="emptyDataMessage">
                <p>{t("There are no business groups")} </p>
                <img src={imgUrl('/images/okr-empty.png')} />
            </div> }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    businessGroup,
    openLegend,
    filterOption,
    isFavorites,
    quarter
  } = state;
  return {
    businessGroup,
    openLegend,
    filterOption,
    isFavorites,
    quarter
  };
};
export default connect(mapStateToProps)(withTranslation()(BgBubbleChart));
